import { proxy } from 'valtio';

import { Diagram, Project, ProjectDesign } from 'models';

const state = proxy({
    project: null as Project | null,
    designs: [] as ProjectDesign[],
    diagrams: [] as Diagram[],
});

export { state };
